/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import AntText from 'antd/es/typography/Text';

const Text = ({ children, align, style, ...props }) => {
  const customStyle = {
    textAlign: align,
    ...style,
  };

  return (
    <AntText style={customStyle} {...props}>
      {children}
    </AntText>
  );
};

Text.propTypes = {
  children: PropTypes.node.isRequired,
  style: PropTypes.object,
  align: PropTypes.oneOf(['center', 'left', 'right', 'justify']),
};

Text.defaultProps = {
  align: undefined,
  style: undefined,
};

export default Text;
